import {Directive, Input, OnInit} from '@angular/core';
import {MatInput} from '@angular/material/input';


@Directive({
    selector: '[appAutofocus]'
})
export class AutofocusDirective implements OnInit {
    @Input() appAutofocus = true;

    constructor(private matInput: MatInput) {
    }

    ngOnInit() {
        setTimeout(() => {
                if (this.appAutofocus) {
                    this.matInput.focus();
                }
            }
        );
    }
}
